/*
 * @Autor: 陈钊贤
 * @Version: 1.0
 * @Date: 2020-05-29 11:27:25
 * @LastEditors: 陈钊贤
 * @Description:
 * @LastEditTime: 2021-08-10 17:26:29
 */
import config from "../config/config";
// import {} from './common-interface'
export const addJS = (url, id) => {
    return new Promise((resolve) => {
        const scriptObj = document.getElementById(id);
        if (scriptObj != null) {
            resolve([]);
        }
        else {
            const scriptDom = document.createElement("script");
            scriptDom.id = id;
            scriptDom.type = "text/javascript";
            scriptDom.src = url;
            document.head.appendChild(scriptDom);
            scriptDom.onload = function () {
                resolve([]);
            };
        }
    });
};
export const echartsJS = () => {
    // 图表
    const url = config.host + "/common/echarts.min.js";
    return addJS(url, "echartsJS");
};
export const echartsJSchina = () => {
    // 图表地图
    const url = config.host + "/common/china.js";
    return addJS(url, "echartsJSchina");
};
export const addQrcodeJs = () => {
    // 二维码
    const url = config.host + "/common/qrcode.min.js";
    return addJS(url, "addQrcodeJs");
};
export const addbankList = () => {
    // 银行支行
    const url = config.host + "/common/bankList.js";
    return addJS(url, "bankList");
};
export const gaodeMapJS = () => {
    // 高德地图
    const url = "https://webapi.amap.com/maps?v=2.0&key=" +
        config.mapKeyApi +
        "&plugin=AMap.Autocomplete,AMap.PlaceSearch,AMap.MarkerCluster,AMap.Geolocation";
    return addJS(url, "gaodeMapJS");
};
